import React from "react";

export default function QuizCategoryCard({ cat, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        height: 110,
        borderRadius: 24,
        background: cat.color,
        cursor: "pointer",
        position: "relative",
        overflow: "hidden",
        padding: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {/* Decorative circles */}
      <div
        style={{
          position: "absolute",
          width: 120,
          height: 120,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.08)",
          top: -40,
          right: -30,
        }}
      />

      <div
        style={{
          position: "absolute",
          width: 70,
          height: 70,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.08)",
          bottom: -15,
          left: -15,
        }}
      />

      <div
        style={{
          color: "#fff",
          fontWeight: "bold",
          fontSize: "1.15rem",
          textAlign: "left",
          width: "70%",
          zIndex: 2,
          lineHeight: 1.3,
        }}
      >
        {cat.name}
      </div>

      <div
        style={{
          fontSize: "4.5rem",
          zIndex: 2,
        }}
      >
        {cat.icon}
      </div>
    </div>
  );
}